export default function SectionMarker({ number, label, className = '' }) {
  return (
    <div className={`flex items-baseline gap-6 ${className}`}>
      <span className="font-serif-display text-5xl md:text-6xl text-taupe/70 leading-none tracking-tighter">{number}</span>
      <span className="hairline-gold h-px w-16" />
      <span className="eyebrow text-matte/80">{label}</span>
    </div>
  );
}
